import * as $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';

export default class TestimonialController {
  private readonly slickTestimonialSelector = '.js-testimonialSlider';
  private $slickTestimonial = $(this.slickTestimonialSelector);

  constructor() {
    this.$slickTestimonial.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots testimonialSlider__dots',
    });
  }
}
